import classNames from 'clsx';
import React, { useContext } from 'react';

import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';
import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';
import { PokerContext } from '@swf/poker';

import styles from './Banner.scss';
import bannerMobilePNG from './assets/banner-mobile.png';
import bannerMobile from './assets/banner-mobile.webp';
import bannerPNG from './assets/banner.png';
import banner from './assets/banner.webp';

const DefaultImage: React.FC = () => {
  const { greaterThan } = useScreenSize();
  const isMobileDevice = !greaterThan(Size.XXSmall);

  return isMobileDevice ? (
    <WebpWithFallback
      src={bannerMobile}
      srcFallback={bannerMobilePNG}
      containerClassName={styles.bannerMobile}
    />
  ) : (
    <WebpWithFallback
      src={banner}
      srcFallback={bannerPNG}
      containerClassName={styles.bannerImage}
    />
  );
};

const Banner: React.FC = () => {
  const {
    state: {
      banner: { backgroundClassName, image = <DefaultImage /> }
    }
  } = useContext(PokerContext);

  return (
    <div className={classNames(styles.background, backgroundClassName)}>
      <div className={styles.content}>{image}</div>
    </div>
  );
};

export default Banner;
